import ControlState from '../../Shared/controlState';
import controlDictionary from '../../Controls/controlDictionary';

export default (
  controlsThatUtilizeHiddenComponents: ControlState[]
): string[] => {
  const isValueProperty = (name: string): boolean => {
    const isGUIDRegex =
      /^control-[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return isGUIDRegex.test(name) || name?.endsWith('-value');
  };

  return controlsThatUtilizeHiddenComponents.map((c) => {
    return Object.keys(controlDictionary[c.kind].getDefaultValue(c)).filter(
      (k) => isValueProperty(k)
    )[0];
  });
};
